import img1 from './images/wiki.png';

function HomePage() {
return (
    <div class= "homepage">
        <h1>
            Hi! I am Will Hayes
        </h1>
        
        <h3>
            Welcome to my wikipedia page
        </h3>
        <img src={img1} alt="logo" height="750px" width="1050px" />
    </div>
    
);

}
export default HomePage;

